export enum CrudOperation {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
}
